<template>
    <div v-loading="loading">
        <content-header>
            <div class="header-left-box" slot="header-left">
                <!-- <retuen-prev></retuen-prev> -->
                <div class="return-prev" @click="retuenPrev">
                    <span class="icon-box">
                        <span class="el-icon-arrow-left"></span>
                    </span>
                    <span class="return-text">{{$t('planLxDetail.FH')}}</span>
                </div>
                <content-header-title>
                    <span>{{ planData.planDto.planName }}</span>
                </content-header-title>
            </div>
            <div class="header-right" slot="header-right">
                <el-button
                    type="primary"
                    size="small"
                    v-if="isBtn.btnCreateTeam"
                    @click="
                        () => {
                            $refs[
                                'studentDialog'
                            ].dialogData.addLxDialog = true;
                        }
                    "
                    >{{$t('planLxDetail.CJTD')}}</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    v-if="isBtn.btnUpdateRace"
                    @click="modifyMatch"
                    >{{$t('planLxDetail.XGLX')}}</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    v-auth="[['teacher', 'student'], 'pro']"
                    v-if="isBtn.btnResetRace"
                    @click="
                        () => {
                            openMatch(planData.planDto.status > 0);
                        }
                    "
                    >{{ (__userData.prodIsFree == 0 && planData.planDto.rule == 0 ) ? $t('planLxDetail.QBJJAN')  : $t('planLxDetail.CZLX')}} </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    v-if="isBtn.btnOpenRace"
                    :disabled="isKtPlan!=$t('planLxDetail.KTLX')"
                    @click="
                        () => {
                            openMatch(planData.planDto.status > 0);
                        }
                    "
                    > {{ isKtPlan }}</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    v-if="isBtn.btnSeekScore"
                    v-auth="[['teacher', 'student'], 'pro']"
                    @click="
                        () => {
                            goShowFraction(planData.planDto.planId);
                        }
                    "
                    >{{$t('planLxDetail.CKCJ')}}</el-button
                >
                <el-button type="primary" size="small" v-if="isBtn.btnSeekScore"
                    v-auth="[['teacher', 'student'], 'pro']" @click="
                        () => {
                            exportScoreBtn(planData.planDto.planId, planData.planDto.planName);
                        }
                    "
                    >{{ $t('planLxDetail.DCCJ') }}</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    v-if="isFiscal && !!planData.planDto.isMarking && !planData.planDto.status"
                    @click="
                        () => {
                            openMarkPaperBtn(planData.planDto.planId)
                        }">{{$t('planLxDetail.LXJHKFYJ')}}</el-button>
                <el-button 
                    type="primary" 
                    size="small"
                    v-if="isFiscal && !!planData.planDto.isMarking && !planData.planDto.status"
                    @click="() => {
                        pullMainScore(planData.planDto.planId)
                    }
                "
                >{{$t('planLxDetail.LQZGTCJ')}}</el-button>
                <el-button
                    type="primary"
                    size="small"
                    v-show="planData.planDto.status == 1"
                    @click="()=>{scheduleDialogVisible = true}"
                    >{{$t('planLxDetail.CSHCX')}}</el-button
                >
            </div>
        </content-header>
        <div class="main">
            <top-sub
                :planDto="planData.planDto"
                :lastingStatisDto="planData.lastingStatisDto"
                :pendingStatisDto="planData.pendingStatisDto"
            ></top-sub>
            <team-list
                :listArr="planData.teamList"
                :pageBtnStatusDto="planData.pageBtnStatusDto"
                :planDto="planData.planDto"
            ></team-list>
        </div>
        <student-dialog
            ref="studentDialog"
            @next="$refs['leaderDialog'].dialogDataLeader.addLxDialog = true"
        ></student-dialog>
        <dialog-plan ref="dialogPlan"></dialog-plan>
        <leader-dialog
            ref="leaderDialog"
            @successClick="successClick"
            @prev="
                $refs['leaderDialog'].dialogDataLeader.addLxDialog = false;
                $refs['studentDialog'].dialogData.addLxDialog = true;
            "
        ></leader-dialog>
        <el-dialog
            :visible.sync="scheduleDialogVisible"
            width="556px"
            center>
            <div class="alldDialog" v-if="resetData.failCount <= 0">
               
                <div class="undone" v-if="resetData.unFinished > 0  && resetData.isStartInited == 1">
                    <div class="mains">
                    <span class="img"></span>
                    <div class="allText">
                        <div class="detial">{{$t('planLxDetail.SJCSHJXZ')}}</div>
                        <div class="team">{{$t('planLxDetail.DQPDXZS')}}<span style="color: #000000 ">{{resetData.waitCount || '1'}}</span>{{$t('planLxDetail.GYJRX')}}<span style="color: #09C579 ">{{newwaitCount}}</span>{{$t('planLxDetail.FZ')}}</div>
                    </div>
                    </div>

                    <div class="body">
                        <p style="color: #0F0D11; font-weight: 700;">{{$t('planLxDetail.YQTS')}} </p>
                        <p>{{$t('planLxDetail.XCJY')}}</p>
                    </div>
                </div>
                 <div class="done" v-if="resetData.unFinished > 0 && resetData.isStartInited == 0">
                    <h2 style="text-align: center;">{{$t('planLxDetail.QKTJH')}}</h2>
                </div>
                <div class="done" v-else-if="resetData.unFinished == 0">
                    <div class="doneHeader">
                        <span class="img"></span>
                        <h1>{{$t('planLxDetail.GXN')}}</h1>
                    </div>
                </div>
            </div>
             <div class="elseDialog" v-else-if="resetData.isStartInited == undefined">
                <div class="done" >
                    <p>{{$t('planLxDetail.SJJDJZZ')}}......</p>
                </div>
            </div>
            <div class="elseDialog" v-else>
                 <div class="done" >
                    <p>{{$t('planLxDetail.DBQXTKNCZSJYCL')}}</p>
                </div>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button 
                    type="primary" 
                    v-if="resetData.waitCount" 
                    size="small"
                    @click="scheduleDialogVisible = false" 
                    style="background: linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%); border-radius: 4px;">
                    {{$t('planLxDetail.ZDL')}}
                </el-button>
                <el-button 
                    type="primary" 
                    size="small"
                    v-else 
                    @click="scheduleDialogVisible = false" 
                    style="background: linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%); border-radius: 4px;">
                    {{$t('planLxDetail.HD')}}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import mini from "./mins";
import topSub from "@/components/detailComponent/top-sub";
import teamList from "@/views/planLxDetail/team-list";
import main from "@/mins/main";
import studentDialog from "@/views/planLxDetail/student-dialog";
import fetch from "@/api/fetch";
import leaderDialog from "@/views/planLxDetail/leader-dialog";
import dialogPlan from "@/views/planLxDetail/dialog-plan";
import { Base64 } from "js-base64";
import {setStore} from '@/utils/common.js'
export default {
    name: "planLxDetail",
    mixins: [mini, main],
    components: {
        topSub,
        teamList,
        studentDialog,
        leaderDialog,
        dialogPlan,
    },
    created() {
        this.getList();
        this.getInitEndTime() // 获取是否可以开通计划
    },
    computed: {
        isBtn() {
            try {
                return this.planData.pageBtnStatusDto.btnOuterStatus;
            } catch {
                return {};
            }
        },
        newwaitCount: function() {
            return this.resetData.waitCount ? Math.ceil(this.resetData.waitCount * 5 / 60) : '1'
        }
    },
    watch:{
        scheduleDialogVisible(){
            if(this.scheduleDialogVisible){
                // 获取初始化状态数据
                this.getResData()
            }
        }
    },
    methods: {
        pullMainScore(planId) {
           fetch.pullMainScore({planId}).then(res => {
               if(res.code == '0')  {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.LQZGTCJCG'), type: 'success' });
               } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
               }
           })
        },
        openMarkPaperBtn(planId) {
            fetch.openMarkPaper({planId, confirmAllSubmit: 0}).then(res => {
                if(res.code == '0') {
                    /**
                     * 根据 isConfirmAllSubmit == 0 - 开放阅卷成功
                     *      isConfirmAllSubmit == 1 - 调取openMarkPaperFun接口
                     * */ 
                    if(res.data.isConfirmAllSubmit != 0) {
                       this.$confirm(this.$t('planLxDetail.CZWJJDXS'), this.$t('planLxDetail.TS'), {
                            confirmButtonText: this.$t('planLxDetail.QD'),
                            cancelButtonText: this.$t('planLxDetail.QX'),
                            type: 'warning'
                            }).then(() => {
                                this.openMarkPaperFun(planId, 1)
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: this.$t('planLxDetail.YQX')
                                });          
                            });
                    } else {
                        this.$notify({ title: '操作', message: res.msg || '开放阅卷成功', type: 'success' });
                    }
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        openMarkPaperFun(planId, num){ // 再次调用开放阅卷接口
            fetch.openMarkPaper({planId, confirmAllSubmit: num}).then(res => {
                if(res.code == '0') {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.KFYJCG'), type: 'success' });
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },

        retuenPrev(){
            let planHomeUrl =  JSON.parse(sessionStorage.getItem('planHomeUrl'))
            this.$router.push(planHomeUrl)
        },
        successClick() {
            this.$refs["leaderDialog"].dialogDataLeader.addLxDialog = false;
            this.getList();
        },
        getResData(){
            // 获取初始化状态
            if(this.resetData.failCount <= 0 && this.resetData.unFinished == 0){
                return false
            }
            let q = JSON.parse(Base64.decode(this.$route.query.q));
            fetch.planInitGetStatus({
                planId: q.id
            }).then(res=>{
                if(res.code == 0){
                    this.resetData = res.data
                    if(this.resetData.failCount <= 0 && this.resetData.unFinished == 0){
                        this.getList()
                    }
                }else{
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        getList() {
            let q = JSON.parse(Base64.decode(this.$route.query.q));
            if(!q.id){
                return false
            }
            this.loading = true
            fetch
                .entryShow({
                    planId: q.id,
                })
                .then((res) => {
                    if (res.code == 0) {
                        this.planData = res.data;
                        setStore('isOpenPaperCopy', res.data.planDto.isOpenPaperCopy.toString())
                    } else {
                        this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg , type: 'error' });
                        this.$router.go(-1)
                    }
                }).finally(()=>{
                    this.loading = false
                });
        },
        // 是否可以开通练习
        getInitEndTime(){
            let q = JSON.parse(Base64.decode(this.$route.query.q));
            fetch.initEndTime({planId: q.id}).then(res=>{
                if(res.code == 0){
                    if(res.data.initInterval <= 0){
                        this.isKtPlan = this.$t('planLxDetail.KTLX')
                    }else{
                        this.isKtPlan = res.data.initInterval + '(min)'
                    }
                }else{
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        modifyMatch() {
            let dialogPlan = this.$refs['dialogPlan']
            dialogPlan.dialogLoading = true
            fetch
                .planGet({
                    planId: this.planId,
                })
                .then((res) => {
                    if (res.code == 0) {
                        this.$refs["dialogPlan"].ruleForm = res.data;
                        let data = res.data
                        this.$refs['dialogPlan'].getMemberNumFlag({
                            pattern: dialogPlan.pattern_lx == 2 ? 1 : dialogPlan.pattern_lx, // --团队赛
                            paperId: data.paperId, //--试卷id
                            professionId: dialogPlan.professionId, //--专业id,
                            orgId: this.__userData ? this.__userData.orgId : null //--机构id
                        })
                        this.$refs[
                            "dialogPlan"
                        ].ruleForm.paperName = this.planData.planDto.paperName;
                    }
                });
            this.$refs["dialogPlan"].dialogData.addLxDialog = true;
        },
        openMatch(isOpen) {
            let { professionId, provinceId, subjectId } = JSON.parse(sessionStorage.getItem('queryData'))
            this.loading = true
            let funAxiosNext = ()=>{
                fetch
                    .planOpen({
                        planId: this.planId,
                        professionId,
                        subjectId,
                        provinceId
                    })
                    .then((res) => {
                        if (res.code == 0) {
                            this.getList();
                            this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                        } else {
                            this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg, type: 'error' });
                        }
                    }).finally(()=>{
                        this.loading = false
                    });
            }
            if (!isOpen) {
                // 开通练习
                if([8, 26].includes(professionId)){
                    funAxiosNext()
                }else{
                    this.$confirm(
                        this.$t('planLxDetail.KTLXDTS')+sessionStorage.getItem('initInterval')+this.$t('planLxDetail.FZCKYJX'),
                        this.$t('planLxDetail.TS'),
                        {
                            confirmButtonText: this.$t('planLxDetail.QD'),
                            cancelButtonText: this.$t('planLxDetail.QX'),
                            type: "warning",
                        }
                    ).then(() => {
                        funAxiosNext()
                    }).catch(()=>{
                        this.loading = false
                    });
                }
                
            } else {
                // 
                // 重置练习
                this.$confirm((this.__userData.prodIsFree == 0 && this.planData.planDto.rule == 0 ) ? this.$t('planLxDetail.SFQBJJUAN') : this.$t('planLxDetail.SFQRCZLX'), this.$t('planLxDetail.TS'), {
                    confirmButtonText: this.$t('planLxDetail.QD'),
                    cancelButtonText: this.$t('planLxDetail.QX'),
                    type: "warning",
                }).then(() => {
                    fetch
                        .planReset({
                            planId: this.planId,
                            professionId,
                            subjectId,
                            provinceId
                        })
                        .then((res) => {
                            if (res.code == 0) {
                                this.getList();
                                this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                            } else {
                                this.$notify({ title: this.$t('planLxDetail.CZ'), message:  res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                            }
                        }).finally(()=>{
                            this.loading = false
                        });
                }).catch(()=>{
                        this.loading = false
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.header-left-box {
    display: flex;
        .return-prev{
        cursor: pointer;
        color: #858C96;
    .icon-box{
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #B4BBCD;
        opacity: 0.2;
        text-align: center;
        line-height: 18px;
        font-size: 14px;
        color: #000;
        display: inline-block;
        vertical-align: 1px;
    }
    .return-text{
        
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        letter-spacing: 1px;
        margin: 0 14px 0 6px;
        vertical-align: 1px;
    }
}
.return-prev:hover{
    color: #5397F7;
    .icon-box{
        color: #5397F7;
        opacity: .5;
    }
}
}
.main {
    padding: 0 24px;
    box-sizing: border-box;
}
.mains {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 36px;
    flex-direction: column;
    .img {
        display: inline-block;
        width: 40px;
        height: 40px;
        background: url('~@/assets/image/hourglass.png');
        background-size: 40px 40px;
    }
    .allText {
        // display: flex;
        // align-items: center;
        margin-left: 18px;
        .detial {
            color: #595964;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #595964;
        }
        .team {
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }

    }
}
.body {
    width: 350px;
    height: 80px;
    margin: auto;
    background-color: #F5F5F7;
    border-radius: 5px;
    padding-top: 5px;
    box-sizing: border-box;
    p {
        margin: 0;
        font-size: 12px;
        padding: 3px 10px;
        box-sizing: border-box;
    }
}
.done {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .doneHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
    }
    .img{
            display: inline-block;
            width: 58px;
            height: 58px;
            background-size: 58px 58px;
            background: url('~@/assets/image/marshalling.png');
    }

    h1 {
        height: 20px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #595964;
        margin-top: 15px;
        margin-bottom: 0px;
    }
}
</style>